import { Injectable } from '@angular/core';
import {SelectItem} from "primeng/api";

@Injectable()
export class DictionaryService {

  horseBreeds: Map<string, string> = new Map();
  bookHorseBreeds: Map<string, string> = new Map();
  horseSexes: Map<string, string> = new Map();
  horseInseminations: Map<string, string> = new Map();
  arabianDocuments: Map<string, string> = new Map();
  thoroughbredDocuments: Map<string, string> = new Map();
  offspringApplicationType: Map<string, string> = new Map();
  issuingDocumentReasons: Map<string, string> = new Map();
  horseDiseaseStatuses: Map<string, string> = new Map();

  constructor() {
    this.createBreeds();
    this.createBookBreeds();
    this.createHorseSexes();
    this.createHorseInseminations();
    this.createArabianDocuments();
    this.createThoroughbredDocuments();
    this.createOffspringApplicationTypes();
    this.createIssuingDocumentReasons();
    this.createHorseDiseaseStatuses();
  }

  private createBreeds(){
    this.horseBreeds.set("ARABIAN", "Czysta krew arabska");
    this.horseBreeds.set("THOROUGHBRED", "Pełna krew angielska");
    this.horseBreeds.set("STANDARDBRED", "kłusak");
    this.horseBreeds.set("ANGLO_ARABIAN", "angloarab");
  }

  private createBookBreeds(){
    this.bookHorseBreeds.set("ARABIAN", "Czysta krew arabska");
    this.bookHorseBreeds.set("THOROUGHBRED", "Pełna krew angielska");
  }

  private createHorseSexes(){
    this.horseSexes.set("STALLION", "ogier");
    this.horseSexes.set("GELDING", "wałach");
    this.horseSexes.set("MARE", "klacz");
  }

  private createHorseInseminations() {
    this.horseInseminations.set("DONOR", "Dawca nasienia");
    this.horseInseminations.set("FATHER", "Ojciec");
  }
  private createArabianDocuments(){
    this.arabianDocuments.set("REGISTRATION_CERTIFICATE", "Zaświadczenie o wpisie");
    this.arabianDocuments.set("REPRODUCE_PERMISSION", "Zezwolenie na dopuszczenie reproduktora do rozrodu");
    this.arabianDocuments.set("EXPORT_CERTIFICATE", "Świadectwo eksportowe");
    this.arabianDocuments.set("EXPORT_BREEDING_CERTIFICATE", "Eksportowe świadectwo pokrycia");
    this.arabianDocuments.set("USE_SPERM_PERMISSION", "Zezwolenie na użycie nasienia");
    this.arabianDocuments.set("REGISTRATION_CERTIFICATE_2", "Świadectwo wpisania konia");
  }

  private createThoroughbredDocuments(){
    this.thoroughbredDocuments.set("REGISTRATION_CERTIFICATE", "Zaświadczenie o wpisie");
    this.thoroughbredDocuments.set("REPRODUCE_PERMISSION", "Zezwolenie na dopuszczenie reproduktora do rozrodu");
    this.thoroughbredDocuments.set("EXPORT_CERTIFICATE", "Świadectwo eksportowe");
    this.thoroughbredDocuments.set("BREEDING_CLEARANCE_NOTIFICATION", "BCN - breeding clearance notification");
    this.thoroughbredDocuments.set("GENERAL_NOTIFICATION_OF_MOVEMENT_ENG", "GNM(ENG) - general notification of movement");
    this.thoroughbredDocuments.set("GENERAL_NOTIFICATION_OF_MOVEMENT_ENG_PL", "GNM(ENG/PL) - general notification of movement");
  }

  private createOffspringApplicationTypes(){
    this.offspringApplicationType.set("BIRTH", "urodziła");
    this.offspringApplicationType.set("MISCARRY", "poroniła");
    this.offspringApplicationType.set("STERILE", "jałowa");
    this.offspringApplicationType.set("DEAD", "martwe");
    this.offspringApplicationType.set("CONSTITUTED_NOT", "nie statnowiona w roku poprzednim");
  }

  private createIssuingDocumentReasons() {
    this.issuingDocumentReasons.set("FIRST_DOCUMENT", "Pierwsze wydanie paszportu");
    this.issuingDocumentReasons.set("LOST_ORIGINAL", "Wydanie duplikatu (oryginał zaginął)");
    this.issuingDocumentReasons.set("DESTROYED_ORIGINAL", "Wydanie duplikatu (oryginał uległ zniszczeniu)");
  }

  private createHorseDiseaseStatuses() {
    this.horseDiseaseStatuses.set("NO_INFORMATION", "brak informacji");
    this.horseDiseaseStatuses.set("MUTATION_PRESENT", "występuje mutacja");
    this.horseDiseaseStatuses.set("FREE_FROM_MUTATION", "wolny od mutacji");
  }

  public getHorseDiseaseStatusSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.horseDiseaseStatuses);
  }

  public getHorseSexSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.horseSexes);
  }

  public getHorseInseminationSelectItem(): SelectItem[] {
  return this.convertToSelectItem(this.horseInseminations);
}

  public getHorseBreedSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.horseBreeds);
  }

  public getBookHorseBreedSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.bookHorseBreeds);
  }

  public getArabianDocumentsSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.arabianDocuments);
  }

  public getThoroughbredDocumentsSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.thoroughbredDocuments);
  }

  public getOffspringApplicationTypes(): SelectItem[] {
    return this.convertToSelectItem(this.offspringApplicationType);
  }

  public getIssuingDocumentReasonSelectItem(): SelectItem[] {
    return this.convertToSelectItem(this.issuingDocumentReasons);
  }

  public convertToSelectItem(map: Map<string, any>): SelectItem[] {
    const items: SelectItem[] = [];
    map.forEach((value, key) => {
      items.push({label: value, value: key});
    });
    return items;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/dictionary.service.ts